import { useTheme } from 'styled-components';

import { Theme } from '@/utils/types';

const fillColorMatrix = {
  [Theme.Beer]: '#008A00',
  [Theme.Wine]: '#EF426F',
  [Theme.Ethanol]: '#117EA6',
};

export const Logo = () => {
  // custom hook to extract the current theme from Theme context
  const t: any = useTheme();
  const theme = t.current;

  // color of logo will be changed based on the theme, default: wine color
  const fillColor = fillColorMatrix[theme as Theme];

  return (
    <svg
      id="Logo"
      xmlns="http://www.w3.org/2000/svg"
      width="186.355"
      height="45.838"
      viewBox="0 0 186.355 45.838"
    >
      <g id="Group_1" data-name="Group 1">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M311.852,31.134a1.745,1.745,0,0,0-1.738,1.738v8.738c0,3.428-2.5,5.826-6.094,5.826-3.573,0-6.095-2.4-6.095-5.826V32.848a1.738,1.738,0,1,0-3.476,0v8.762c0,5.385,4.014,9.3,9.546,9.3s9.547-3.916,9.547-9.3V32.848A1.654,1.654,0,0,0,311.852,31.134Z"
          transform="translate(-204.361 -21.619)"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M383.267,47.223H372.645V32.929a1.738,1.738,0,0,0-3.477,0V50.7h14.1a1.738,1.738,0,1,0,0-3.476Z"
          transform="translate(-256.219 -21.676)"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M435.077,31.4a1.729,1.729,0,0,0-2.424.391l-6.07,8.42-6.07-8.42a1.736,1.736,0,0,0-2.815,2.032l7.025,9.767v5.262a1.738,1.738,0,1,0,3.476,0V43.883l7.27-10.083A1.724,1.724,0,0,0,435.077,31.4Z"
          transform="translate(-289.671 -21.591)"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M487.89,31.191a1.738,1.738,0,0,0,0,3.475H496.8L485.809,50.7h15.47a1.738,1.738,0,1,0,0-3.476h-8.91l10.989-16.032Z"
          transform="translate(-337.173 -21.676)"
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M571.427,47.223H560.8V42.817h4.846a1.738,1.738,0,1,0,0-3.476H560.8V34.666h10.622a1.738,1.738,0,1,0,0-3.475h-14.1V50.7h14.1a1.738,1.738,0,0,0,0-3.476Z"
          transform="translate(-386.81 -21.676)"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          d="M236.249,32.026a6.733,6.733,0,0,1,4.258,1.494,1.742,1.742,0,0,0,2.179-2.718,10.284,10.284,0,1,0-6.437,18.308,10.4,10.4,0,0,0,6.437-2.252,1.741,1.741,0,0,0-2.179-2.717,6.739,6.739,0,0,1-4.258,1.493,6.8,6.8,0,1,1,0-13.609Z"
          transform="translate(-156.833 -19.843)"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M159.929,28.55A10.28,10.28,0,1,0,170.21,38.831,10.3,10.3,0,0,0,159.929,28.55Zm0,17.11a6.829,6.829,0,1,1,6.829-6.829A6.832,6.832,0,0,1,159.929,45.66Z"
          transform="translate(-103.863 -19.843)"
        />
        <path
          id="Path_8"
          data-name="Path 8"
          d="M34.9,29.481A18.989,18.989,0,0,0,19.745.109a17.1,17.1,0,0,0-2.961.122A19.006,19.006,0,0,0,18.251,38.1a16.976,16.976,0,0,0,2.962-.123,18.376,18.376,0,0,0,5.605-1.566l8,9.521,1.077-.294A10.187,10.187,0,0,0,42.556,40.1l.441-1ZM18.349,34.62a15.527,15.527,0,0,1-1.2-30.938,15.966,15.966,0,0,1,2.423-.1,15.528,15.528,0,0,1,1.2,30.939A15.847,15.847,0,0,1,18.349,34.62Zm17.623,7.319L34.7,40.422a9.123,9.123,0,0,0,1.518-1l.024-.025c.123-.122.49-.685-.318-1.64a1.245,1.245,0,0,0-1.444-.49h-.025a8.847,8.847,0,0,1-1.616.98l-3.011-3.574a18.776,18.776,0,0,0,2.816-2.423l6.192,7.343A6.655,6.655,0,0,1,35.972,41.939Z"
          transform="translate(-0.001 -0.091)"
        />
        <path
          id="Path_9"
          data-name="Path 9"
          d="M40.854,38.054c-9.3-.245-7.269-6.119-5.7-9.618s-.489-4.969-3.426-5.214c-6.266-.514-12.311,8.4-10.182,15.4,2.154,7.1,11.944,12.018,19.189,6.731C43.743,43.121,44.378,38.152,40.854,38.054Zm-10.4,1.077a2.69,2.69,0,0,1-1.126,1.641,2.723,2.723,0,0,1-1.958.367,2.751,2.751,0,0,1-1.64-1.126,2.607,2.607,0,0,1-.368-1.959,2.687,2.687,0,0,1,1.127-1.64,2.605,2.605,0,0,1,1.958-.367,2.685,2.685,0,0,1,1.64,1.126A2.536,2.536,0,0,1,30.451,39.131Zm1.42-9.228a2.758,2.758,0,0,1-1.126,1.641,2.6,2.6,0,0,1-1.958.367,2.753,2.753,0,0,1-1.64-1.126,2.6,2.6,0,0,1-.368-1.959,2.685,2.685,0,0,1,1.126-1.64,2.606,2.606,0,0,1,1.959-.367,2.683,2.683,0,0,1,1.64,1.126A2.536,2.536,0,0,1,31.871,29.9Zm6.486,12.8a2.759,2.759,0,0,1-1.126,1.641,2.605,2.605,0,0,1-1.958.367,2.684,2.684,0,0,1-1.64-1.126,2.718,2.718,0,0,1-.367-1.959,2.606,2.606,0,0,1,3.083-2.007,2.685,2.685,0,0,1,1.64,1.126A2.5,2.5,0,0,1,38.357,42.7Z"
          transform="translate(-14.65 -16.129)"
          fill={fillColor}
        />
        <path
          id="Path_10"
          data-name="Path 10"
          d="M84.346,39.284a3.227,3.227,0,0,0-1.958-1.371,3.122,3.122,0,0,0-3.7,2.4,3.152,3.152,0,0,0,.416,2.349,3.194,3.194,0,0,0,1.958,1.371,3.058,3.058,0,0,0,2.35-.44,3.23,3.23,0,0,0,1.371-1.959A3.286,3.286,0,0,0,84.346,39.284Z"
          transform="translate(-54.568 -26.294)"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};
